// Who the scanner's requests act as, for gating. Its own module so a flow that filters
// by capability (Marker's actions) need not import the tool registry that renders it.

import type { ToolViewer } from './types';

/**
 * What an operator token is allowed, mirroring authenticateScanner in api/src/app.js.
 * The kiosk's requests carry that token, so its tools gate on this set, never on the
 * person's own account. Change both together or the list offers what the API refuses.
 */
export const KIOSK_OPERATOR_CAPS = Object.freeze({
  can_manufacturing: true,
  can_operations: true,
  can_sales: true,
});

/** The capability flags the scanner's requests will actually carry. */
export function capabilitiesFor(viewer: ToolViewer): unknown {
  return viewer.kiosk ? KIOSK_OPERATOR_CAPS : viewer.user;
}
